import { Component, OnInit, Inject } from '@angular/core';
import { DataService } from '../data.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { FormControl, FormGroup, Validators } from '@angular/forms';


@Component({
  selector: 'app-metas-edit',
  templateUrl: './metas-edit.component.html',
  styleUrls: ['./metas-edit.component.css']
})
export class MetasEditComponent implements OnInit {
  errMsg:any;
  okMsg:any;
  loading:boolean=false;
  tiempoMsg:number=2300;
  resultado:any=[];
  esNuevo:boolean;
  gpo:any=[];
  
  enviandoCorreo:number=-1;
  admonCorreo:any=[];
  envioMail:any;

  thisForm = new FormGroup({
    area: new FormControl(this.data.item.idGpo, [Validators.required]),
    act: new FormControl(this.data.item.metaAct, [Validators.required]),
    asis: new FormControl(this.data.item.metaAsis, [Validators.required]),
  });

  constructor(private dataService: DataService, public dialogRef: MatDialogRef<MetasEditComponent>, @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
    //console.log(this.data);
    if(this.data){
      if(this.data.id > 0){
        this.esNuevo=false;
      }
      else
        this.esNuevo=true;
    }
    
    this.dataService.getGrupos().subscribe(
                          rows => {   
                                  this.gpo = <any>rows
                                  },          
                          error => this.errMsg = <any>error,
                          () => this.fnGruposCargados());    
    this.dataService.getVars("ENV_LOG").subscribe(
                          rows => {   
                                  this.enviandoCorreo = <any>rows
                                  },          
                          error => this.errMsg = <any>error,
                          () => this.fnEnvio_Correo_Log_Obtenido());                            
    
  }

  fnGruposCargados(){
    //console.log(this.gpo)
  }

  fnEnvio_Correo_Log_Obtenido(){
    //console.log(this.enviandoCorreo);
    if(this.enviandoCorreo == 1){
      //this.correoLog = this.enviandoCorreo[0].;
      this.dataService.getEnvioLog().subscribe(
                          rows => {   
                                  this.admonCorreo = <any>rows
                                  },          
                          error => this.errMsg = <any>error,
                          () => this.fnAdmonLogObtenido());
    }
  }

  fnAdmonLogObtenido(){
    //console.log(this.admonCorreo);
  }

  fnKeyPress(t, e){
    this.errMsg="";
    if (!this.dataService.validKey(t,e)){
        this.errMsg="Caracter inválido!";
        setTimeout(() => {
            this.errMsg="";
        }, this.tiempoMsg);
        return false;
    }
    else
      return true;
  }

  fnKeyUp(t, e){
    //console.log(e);
  }

  fnMuestraMensaje(tipo:string, msg:string, changeLoading:boolean, closeDialog:boolean){
    //console.log("Loading: " + this.loading);
    //console.log("Change: " + changeLoading);
    this.okMsg = "";
    this.errMsg = "";
    if(tipo=="OK")
      this.okMsg = msg;
    if(tipo=="ERR")
      this.errMsg = msg;
    setTimeout(() => {
      this.okMsg = "";
      this.errMsg = "";
      if(changeLoading)
        this.loading = !this.loading;
      if(closeDialog)
        this.dialogRef.close();
    }, this.tiempoMsg);
  }

  onChange(idEl, item, tipo){
    //console.log("onChange: " + tipo)
    this.onClick(idEl,item,tipo);
  }

  onClick(idEl, item, tipo){
    //console.log("onClick: " + idEl);
    //console.log(item);
    if(tipo=="GRUPO" && idEl != undefined){
      this.data.item.idGpo = idEl;
      this.thisForm.controls["area"].setValue(idEl);
    }
  }

  fnGuardar(){
    this.loading = true;
    if(this.esNuevo){
      //console.log("GUARDAR");
      //--> Asignación de actividades y asistencia para cada Área (No usa formulario):
      var auxStr = "";
      var auxAct = -1;
      var auxAsis = -1;
      for(var g = 0; g < this.gpo.length; g++){
        auxAct = -1;
        auxAsis = -1;
        auxStr = (<HTMLInputElement>document.getElementById("txtAct_" + this.gpo[g].idGrupo)).value;
        if(auxStr)
          auxAct = parseInt(auxStr);
        auxStr = (<HTMLInputElement>document.getElementById("txtAsis_" + this.gpo[g].idGrupo)).value;
        if(auxStr)
          auxAsis = parseInt(auxStr);
        //console.log("idGrupo = " + this.gpo[g].idGrupo + "\nActs: " + auxAct)
        if(auxAct < 0 || auxAsis < 0){
          if(auxAct < 0){
            this.fnMuestraMensaje("ERR", "Capture número de 'actividades' para '" + this.gpo[g].grupo + "'.", true, false)
            return;
          }
          if(auxAsis < 0){
            this.fnMuestraMensaje("ERR", "Capture número de 'asistentes' para '" + this.gpo[g].grupo + "'.", true, false)
            return;
          }
        }
        else{
          this.gpo[g].nvaAct = auxAct;
          this.gpo[g].nvaAsis = auxAsis;
        }
      }
      //console.log("GUARDA!")
      var arrGpo = [];
      var arrAct = [];
      var arrAsis = [];
      for(var g = 0; g < this.gpo.length; g++){
        arrGpo.push(this.gpo[g].idGrupo);
        arrAct.push(this.gpo[g].nvaAct);
        arrAsis.push(this.gpo[g].nvaAsis);
      }
      this.dataService.insLog(26,'META', "NUEVA:" + this.gpo.join(';'),'').subscribe(
                      row => { var l = <any>row; }, error => this.errMsg = <any>error, () => "" );    
      this.dataService.insMeta(this.data.fecha.format('YYYYMM'), arrGpo.join(','), arrAct.join(','), arrAsis.join(',')).subscribe(
                      rows => {   
                              this.resultado = <any>rows
                              },          
                      error => this.errMsg = <any>error,
                      () => this.fnMetaGuardada());           
    
    }
    else{
      //--> Asignación de actividades y asistencia para el Área específica:
      if(this.thisForm.valid){
        this.dataService.insLog(26,'META', "EDICIÓN " + this.dataService.findItemInObject(this.gpo, this.thisForm.controls["area"].value, "idGrupo").grupo + " (" + this.data.fecha.format('YYYYMM') + "): Acts. =" + this.thisForm.controls["act"].value + ", Asis. = " + this.thisForm.controls["asis"].value,'').subscribe(
                      row => { var l = <any>row; }, error => this.errMsg = <any>error, () => "" );    

        this.dataService.updMeta(this.data.fecha.format('YYYYMM'), this.thisForm.controls["area"].value, this.thisForm.controls["act"].value, this.thisForm.controls["asis"].value).subscribe(
                        rows => {   
                                this.resultado = <any>rows
                                },          
                        error => this.errMsg = <any>error,
                        () => this.fnMetaEditada());           
      }
      else{
        if(this.thisForm.controls["act"].errors){
          if(this.thisForm.controls["act"].errors.required)
            this.fnMuestraMensaje("ERR", "Capture número de 'actividades'.", true, false)
          return;
        }
        if(this.thisForm.controls["asis"].errors){
          if(this.thisForm.controls["asis"].errors.required)
            this.fnMuestraMensaje("ERR", "Capture número de 'asistentes'.", true, false)
          return;
        }
      }
    }
  }

  fnMetaGuardada(){
    //console.log(this.resultado);
    if(this.resultado == this.gpo.length){
      if(this.admonCorreo.length > 0){    
        var msg = "Mes: '" + this.data.fecha.format('MMM YYYY') + "'∙";
        for(var g = 0; g < this.gpo.length; g++){
          msg += "Área: '" + this.dataService.findItemInObject(this.gpo, this.gpo[g].idGrupo, "idGrupo").grupo + "'∙";
          msg += "Actividades: '" + this.gpo[g].nvaAct + "'∙";
          msg += "Asistentes: '" + this.gpo[g].nvaAsis + "'∙";
        }
        this.dataService.sendMailLog("Meta nueva", msg, this.admonCorreo[0].mail, this.admonCorreo[0].nombre).subscribe(
                              rows => {   
                                      this.envioMail = rows
                                      },          
                              error => this.errMsg = <any>error,
                              () => this.fnEmailEnviado());     
      }
      this.fnMuestraMensaje("OK", "Metas almacenadas", false, true);
    }
    else{
      this.fnMuestraMensaje("ERR", "Error al almacenar meta", true, false);
      setTimeout(() => {
        this.loading = false;
      }, this.tiempoMsg);
    }
  }  
  
  fnMetaEditada(){
    //console.log(this.resultado);
    if(this.resultado == 1){
      if(this.admonCorreo.length > 0){    
        var auxGpo = this.dataService.findItemInObject(this.gpo, this.thisForm.controls["area"].value, "idGrupo").grupo;
        var msg = "Mes: '" + this.data.fecha.format('MMM YYYY') + "'∙";
        msg += "Área: '" + auxGpo + "'∙";
        msg += "Actividades: '" + this.thisForm.controls["act"].value + "'∙";
        msg += "Asistentes: '" + this.thisForm.controls["asis"].value + "'∙";
        this.dataService.sendMailLog("Meta editada » '" + auxGpo + "'.", msg, this.admonCorreo[0].mail, this.admonCorreo[0].nombre).subscribe(
                              rows => {   
                                      this.envioMail = rows
                                      },          
                              error => this.errMsg = <any>error,
                              () => this.fnEmailEnviado());     
      }
      this.okMsg = "Meta actualizada"
      setTimeout(() => {
        this.okMsg = "";
        this.loading = false;
        this.dialogRef.close();
      }, this.tiempoMsg);
    }
    else{
      this.errMsg = "Error al actualizar meta!"
      setTimeout(() => {
        this.errMsg = "";
        this.loading = false;
      }, this.tiempoMsg);
    }
  }

  fnEmailEnviado(){
    console.log("Correo enviado")
  }

}
